import * as React from "react";
import { PieChart, Pie, Cell } from "recharts";

const RADIAN = Math.PI / 180;
const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, payload }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const xPos = cx + radius * Math.cos(-midAngle * RADIAN);
    const yPos = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
        payload.value === 0 ? <></> : 
        <text style={{fontSize: "12px"}} x={xPos} y={yPos} fill="white"
            textAnchor="middle"
            dominantBaseline="central" fontSize="10">
            {`${Math.round(payload.value)}%`}
        </text>
    );
}

export const GenderDonut = ({ data, colors }) => {
    if (data.reduce((acc, cur) => acc += cur.value, 0) === 0) {
        return <span>NA</span>
    } else if (data.filter(d => d.name === 'Unknown')[0].value === 100) {
        //this is only for WASH U
        return <span>NA</span>
    }else {
        return <PieChart width={100} height={100}>
            <Pie
                data={data}
                cx={45}
                cy={45}
                innerRadius={20}
                outerRadius={50}
                dataKey="value"
                labelLine={false}
                label={renderLabel}
                isAnimationActive={false}//Hacky way to show labels after initial render. Animation transition is lost.
            >
                {

                    data.map(d => <Cell fill={colors[d.name]} key={d.name} />)
                }
            </Pie>
        </PieChart>
}
}
